<template>
    <div class="alarmMessageSet">
        <div class="columnMain">
            <div style="position: absolute; top: -24px; right: 50px">
                <el-button @click.native.prevent="openEdit(true)" size="medium" icon="el-icon-edit" style="padding: 6px">{{ $t('systemSetting.levelSet') }}</el-button>
            </div>
            <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="value"
                    filterable
                    :filter-placeholder="$t('systemSetting.searchFilter')"
                    :titles="[$t('systemSetting.alarmMesg1'), $t('systemSetting.alarmMesg2')]"
                    :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
                    @change="handleChange"
                    @right-check-change="handleRightChange"
                    :data="data">
                <div slot-scope="{ option }" class="tagItem">
                    <div :style="{ color: alarmLevelColor(option.alarmLevel)}">{{ option.label }}</div>
                    <div class="tagItemAction" v-if="option.levelName && option.checkPeriod && value.includes(option.key)">
                        {{option.levelName}}/{{option.checkPeriod}}分钟
                    </div>
                </div>
            </el-transfer>
        </div>

        <template v-if="editVis">
            <el-dialog :title="$t('systemSetting.levelSet')" :visible.sync="editVis" append-to-body width="700px" :close-on-click-modal="false"  :show-close= false :close-on-press-escape="false" custom-class="dialog-custom-class" top="30vh">
                <el-form @submit.native.prevent :model="form" class="tableSearchForm" style="width: 600px; margin-left: 30px" size="small" ref="editForm">

                    <div class="alarmSelectBox">
                        <div style="width: 100%">
                            <div style="margin: 10px 0">当前所选告警: </div>
                            <template v-if="form.isClick">
                                <div v-for="(item, index) in getAlarmRow" :key="index" class="getAlarmRowItem">{{item.label}}</div>
                            </template>
                            <template v-else>
                                <div v-for="(item, index) in getSelectAlarmRow" :key="index" class="getAlarmRowItem">{{item.label}}</div>
                            </template>
                        </div>
                        <div style="width: 100%">
                            <div style="margin: 16px 0 5px 0">请选择消息等级: </div>

                            <el-radio-group v-model="form.levelId" :min="1" :max="1">
                                <el-radio v-for="city in levelList" :label="city.id" :key="city.id" style="margin: 10px; display: block; ">
                                    <span style="font-size: 16px">{{city.levelName}}</span>
                                    <span style="text-align: right; margin-left: 20px; font-size: 16px">{{city.checkPeriod}}分钟</span>
                                </el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="handleClose">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="handleEdit">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </template>
    </div>
</template>

<script>
    import { getUnselectedList, getSelectedList, setRelation, getUseAlarmList, editRelation } from "@/api/spms";
    import { mapGetters } from "vuex";
    import i18n from "@/lang";

    export default {
        name: "alarmMessageSet",
        props: ['groupId'],
        data(){
            return {
                levelList: [],
                value: [],
                data: [],

                editVis: false,
                form: {
                    isClick: false,
                    levelId: '',
                },
                rightChecked: [],
                movedKeys: [],
            }
        },
        computed: {
            ...mapGetters(["language"]),
            getAlarmRow(){
                if(this.movedKeys.length === 0){
                    return [];
                }else{
                    return this.data.filter(i => { return this.movedKeys.includes(i.key)});
                }
            },
            getSelectAlarmRow(){
                if(this.rightChecked.length === 0){
                    return [];
                }else{
                    return this.data.filter(i => { return this.rightChecked.includes(i.key)});
                }
            },
        },
        mounted() {
            this.initData();
        },
        methods: {
            handleChange(value, direction, movedKeys) {
                this.movedKeys = movedKeys;
                if(direction === 'right'){
                    this.openEditBySelect();
                }else{
                    const alarmNos = this.getAlarmRow.map(i => i.alarmNo);
                    setRelation({groupId: this.groupId, flag: 0, alarmNos: alarmNos.join(',')}).then(res => {
                        if(res && res.data && res.data.success){
                            this.$message.success(i18n.t("ems.SuccessfulOperation"))
                        }else{
                            this.$message.error(i18n.t("ems.operationFailed"));
                            this.value.splice(-this.movedKeys.length);
                        }
                    }).catch(err => {
                        this.$message.error(i18n.t("ems.operationFailed"));
                        this.value.splice(-this.movedKeys.length);
                        console.log(err);
                    });
                }
            },
            async initData() {
                const res1 = await getSelectedList({groupId: this.groupId});
                const temp1 = res1.data.data || [];
                const select = temp1.map(i => {
                    return {key: i.alarmId, label: i.alarmNo + ' ' + i.alarmName, alarmNo: i.alarmNo, id: i.id, alarmLevel: i.alarmLevel, levelName: i.levelName, checkPeriod: i.checkPeriod}
                });


                const res2 = await getUnselectedList({groupId: this.groupId});
                const temp2 = res2.data.data || [];
                const unselect = temp2.map(i => {
                    return {key: i.alarmId, label: i.alarmNo + ' '+i.alarmName, alarmNo: i.alarmNo, id: i.id, alarmLevel: i.alarmLevel}
                });
                this.data = select.concat(unselect);
                this.value = select.map(i => i.key);
                console.log(this.data, this.value)
                getUseAlarmList().then(res => {
                    this.levelList = res.data.data || [];
                });
            },
            alarmLevelColor(val){
                if (val === 3) {
                    // alarmLevel
                    return '#ff1313'
                } else if (val === 2) {
                    return 'Orange'
                } else if (val === 1) {
                    return 'yellow'
                } else {
                    return '#9c9c9c'
                }
            },
            openEdit(){
                if(this.rightChecked.length == 0){
                    this.$message.warning("请在右侧告警列表选择一条数据！")
                    return false;
                }
                this.form = {
                    levelId: '',
                    isClick: false,
                };
                this.editVis = true;

            },
            openEditBySelect(){
                this.editVis = true;
                this.form = {
                    levelId: '',
                    isClick: true,
                }
            },

            handleEdit(){
                if(this.form.levelId === '' || this.form.levelId === undefined){
                    this.$message.warning("请选择消息等级！")
                    return false;
                }
                if(this.form.isClick){
                    const alarmNos = this.getAlarmRow.map(i => i.alarmNo);
                    setRelation({groupId: this.groupId, flag: 1, alarmNos: alarmNos.join(','), levelId: this.form.levelId}).then(res => {
                        if(res && res.data && res.data.success){
                            this.$message.success(i18n.t("ems.SuccessfulOperation"));
                            this.movedKeys = [];
                            this.editVis = false;
                            this.initData();
                        }else{
                            this.$message.error(i18n.t("ems.operationFailed"));
                            this.value.splice(-this.movedKeys.length);
                        }
                    }).catch(err => {
                        this.$message.error(i18n.t("ems.operationFailed"));
                        this.value.splice(-this.movedKeys.length);
                        console.log(err);
                    });
                }else{
                    const alarmNos = this.getSelectAlarmRow.map(i => i.id);
                    editRelation({ids: alarmNos.join(','), levelId: this.form.levelId}).then(res => {
                        if(res && res.data && res.data.success){
                            this.$message.success(i18n.t("ems.SuccessfulOperation"));
                            this.movedKeys = [];
                            this.editVis = false;
                            this.initData();
                        }else{
                            this.$message.error(i18n.t("ems.operationFailed"));
                        }
                    }).catch(err => {
                        this.$message.error(i18n.t("ems.operationFailed"));
                        console.log(err);
                    });
                }

            },
            handleRightChange(keys, rows){
                console.log(keys, rows);
                this.rightChecked = keys;
            },
            handleClose(){
                this.editVis = false;
                if(this.movedKeys.length > 0){
                    this.value.splice(-this.movedKeys.length);
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/site";
    .alarmMessageSet{
        height: 100%;
        box-sizing: border-box;
        /*padding: 0 30px;*/
        .columnMain{
            /*background-color: rgb(22,22,22);*/
            height: 720px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        }
    }
</style>
<style lang="scss">
    .alarmMessageSet{
        .el-transfer-panel__item .el-checkbox__input {
            position: absolute;
            top: 8px;
        }
        .el-transfer-panel__header{
            height: 40px;
            line-height: 40px;
            background: #343434;
            margin: 0;
            padding-left: 15px;
            border-bottom: 1px solid #292929;
            box-sizing: border-box;
            color: #a9a9a9;
            .el-checkbox{
                .el-checkbox__label{
                    color: #e9e9e9;
                }
            }
        }
        .el-transfer-panel{
            border: 1px solid #151515;
            border-radius: 4px;
            overflow: hidden;
            background: #1e1e1e;
            display: inline-block;
            vertical-align: middle;
            width: 580px;
            height: 700px;
            max-height: 100%;
            box-sizing: border-box;
            position: relative;
        }
        .el-checkbox-group{
            height: 560px;
        }
        .tagItem{
            font-size: 14px;
            color: #9c9c9c;
            display: flex;
            align-items: center;
            /*justify-content: space-between;*/
            position: relative;
            /*background: rgba(68, 205, 234, 0.23);*/
            .tagItemAction{
                position: absolute;
                right: 0;
                height: 100%;
                top: 0;
                font-size: 14px;
                .el-button--text {
                    color: rgb(68, 205, 234);
                }
            }
        }

        .el-transfer-panel__filter .el-input__inner {
            font-size: 14px;
        }
        .el-transfer__buttons {
            display: inline-block;
            vertical-align: middle;
            padding: 0 20px;
        }

        .el-input__inner {
            background-color: #5f5f5f;
            border: 1px solid #494949;
            color: #e9e9e9;
        }
        .el-transfer__buttons{
            .el-transfer__button{
                display: block !important;
            }
            .el-button+.el-button{
                margin-left: 0;
            }
        }
        .el-checkbox:last-of-type {
            margin-right: 30px;
        }
    }



    .tagDictList .el-table__header-wrapper thead th {
        font-size: 13px !important;
        height: 40px !important;
    }

    .alarmSelectBox{
        margin-top: -20px;
        width: 100%;
        font-size: 16px; color: #e9e9e9;
        .getAlarmRowItem{
            color: rgb(68, 205, 234);
            margin-top: 5px;
            font-size: 14px;
        }
    }
</style>